import { Unit } from "uom";
export function lengthByLength(name, left, right) {
    return Unit.times(name, "Area", left, right);
}
export function areaByLength(name, left, right) {
    return Unit.times(name, "Volume", left, right);
}
export function durationByElectricCurrent(name, left, right) {
    return Unit.times(name, "ElectricCharge", left, right);
}
export function massByAcceleration(name, left, right) {
    if (!left || !right) {
        throw new Error("The arguments cannot be undefined");
    }
    return Unit.times(name, "Force", left, right);
}
export function forceByLength(name, left, right) {
    return Unit.times(name, "Energy", left, right);
}
export function electricalPotentialByDuration(name, left, right) {
    return Unit.times(name, "MagneticFlux", left, right);
}
export function luminousIntensityBySolidAngle(name, left, right) {
    return Unit.times(name, "LuminousFlux", left, right);
}
export function massByArea(name, left, right) {
    return Unit.times(name, "MomentOfInertia", left, right);
}
export function dimensionlessByDimensionless(name, left, right) {
    return Unit.times(name, "SoundPressureLevel", left, right);
}
export function specificEnthalpyByTemperature(name, left, right) {
    return Unit.times(name, "SpecificHeatCapacity", left, right);
}
export function powerByDuration(name, left, right) {
    return Unit.times(name, "Energy", left, right);
}
//# sourceMappingURL=unit-times.js.map